<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>attach_file</mat-icon>
    </div>
    <div class="cr-header-text">
      <h2 class="cf-dlg-title">Importar cuadro de amortización</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="uploading" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="uploading" message="Adjuntando cuadro de amortización…"></app-loading-state>

  <ng-container *ngIf="!uploading">
    <div class="cf-dlg-body">
      <div class="cr-info" *ngIf="hasFile">
        <mat-icon>info</mat-icon>
        <span>Este crédito ya tiene un cuadro de amortización adjunto. Si importas otro, sustituirá al actual.</span>
      </div>

      <div class="cr-error" *ngIf="errorMessage">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}{{ fileName ? ' (' + fileName + ')' : '' }}</span>
      </div>

      <div class="cr-upload">
        <label class="cf-dlg-upload-btn" for="credit-attachment-file">
          <mat-icon>file_upload</mat-icon>
          <span>Seleccionar fichero Excel (.xlsx)</span>
        </label>
        <input id="credit-attachment-file" class="cr-upload-input" type="file" accept=".xlsx" (change)="onFileSelected($event)">
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
    </div>
  </ng-container>
</div>
